const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/eCheckin/ECheckinForm.tsx';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import PersAngaben from 'App/config/ukbb/eCheckin/sections/PersAngaben';
import textMap from 'App/config/ukbb/eCheckin/translations';
import Finalize from 'App/config/ukbb/eCheckin/sections/Finalize';
import KontaktPerson from 'App/config/ukbb/eCheckin/sections/KontaktPerson';
import HausArzt from 'App/config/ukbb/eCheckin/sections/HausArzt';
import Versicherung from 'App/config/ukbb/eCheckin/sections/Versicherung';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), [formId]);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <PersAngaben path={'persAngaben'} title={textMap.persAngaben} />
            <KontaktPerson path={'contact'} title={textMap.contact} />
            <HausArzt path={'einwArzt'} title={textMap.doctor} />
            <Versicherung path={'versicherung'} title={textMap.versicherungLabel} />
            <Finalize path={'finalize'} title={textMap.finalizeTitle} />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
